import { CampaignCardImage } from "./CampaignCardImage";
import { CampaignCardBody } from "./CampaignCardBody";

export const CampaignCard = ({ campaign, index, reverse }) => {
  return (
    <article
      data-testid={`campaign-${index}`}
      className="hairline-b border-b group"
    >
      <div className="max-w-[1480px] mx-auto px-5 md:px-10 py-14 md:py-24 grid grid-cols-12 gap-6 md:gap-12 items-center">
        <CampaignCardImage campaign={campaign} index={index} reverse={reverse} />
        <CampaignCardBody campaign={campaign} index={index} reverse={reverse} />
      </div>
    </article>
  );
};
